import React, { useState, useEffect } from "react";
import "./OrchesCapability.css";
import img1 from "../orchesassets/img1.png";
import img2 from "../orchesassets/img2.png";
import img3 from "../orchesassets/img3.png";
import img4 from "../orchesassets/img4.png";
import img5 from "../orchesassets/img5.png";
import img6 from "../orchesassets/img6.png";

export default function OrchesCapability() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardsToShow, setCardsToShow] = useState(3);

  const cases = [
    {
      img: img1,
      name: "Application Containerization",
      text: "Evaluate applications, dependencies, and orchestration requirements.",
    },
    {
      img: img2,
      name: "Container Orchestration",
      text: "Design Kubernetes-based orchestration architectures tailored to your environment.",
    },
    {
      img: img3,
      name: "CI/CD Integration",
      text: "Implement scaling, security, and governance policies.",
    },
    {
      img: img4,
      name: "Security & Compliance",
      text: "Connect orchestration platforms with DevOps pipelines and monitoring tools.",
    },
    {
      img: img5,
      name: "Cloud & Hybrid Deployment",
      text: "Continuously monitor performance and optimize orchestration workflows.",
    },
    {
      img: img6,
      name: "Cloud & Hybrid Deployment",
      text: "Continuously monitor performance and optimize orchestration workflows.",
    },
  ];

  const maxSlides = Math.max(0, cases.length - cardsToShow);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setCardsToShow(3);
      } else if (window.innerWidth >= 576) {
        setCardsToShow(2);
      } else {
        setCardsToShow(1);
      }
      setCurrentSlide(0);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleDotClick = (index) => {
    if (index <= maxSlides) {
      setCurrentSlide(index);
    }
  };

  return (
    <div id="orches-capability" className="outsourcemainclass">
      <div className="capability">
         <button className="btn">Let's Discuss Your Project</button>
        <h2 className="heading">Why Choose BastionEx?</h2>
        <p className="subheading">
          Delivering Secure, Compliant, and High-Performance CI Solutions
        </p>

        <div className="cards">
          {cases.map((item, index) => (
            <div className="card" key={index}>
              <img src={item.img} alt="error" />
              <span>{item.name}</span>
              <p className="text">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="carousel-container">
          <div className="carousel-wrapper">
            <div
              className="carousel-track"
              style={{
                transform: `translateX(calc(-${(100 / cardsToShow) * currentSlide}% - ${currentSlide * 12}px))`,
              }}
            >
              {cases.map((item, index) => (
                <div
                  className="card"
                  key={index}
                  style={{
                    flex: `0 0 calc(${100 / cardsToShow}% - ${
                      ((cardsToShow - 1) * 12) / cardsToShow
                    }px)`,
                  }}
                >
                  <img src={item.img} alt="error" />
                  <span>{item.name}</span>
                  <p className="text">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          {maxSlides > 0 && (
            <div className="carousel-dots">
              {Array.from({ length: maxSlides + 1 }).map((_, index) => (
                <button
                  key={index}
                  className={`dot ${currentSlide === index ? "active" : ""}`}
                  onClick={() => handleDotClick(index)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
